module.exports = "<svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M10.07 10.588L13 7.813 10.07 5v1.988H5.831a.796.796 0 0 0-.594.243.804.804 0 0 0-.238.582V11h1.663V8.6h3.406v1.988zm5.668-3.151c.35.4.35.776 0 1.126l-7.195 7.212a.762.762 0 0 1-.562.225.762.762 0 0 1-.562-.225L.225 8.563A.765.765 0 0 1 0 8c0-.225.075-.413.225-.563L7.419.225A.762.762 0 0 1 7.981 0c.225 0 .412.075.562.225l7.195 7.212z\" fill-rule=\"nonzero\"/></svg>\n"


//////////////////
// WEBPACK FOOTER
// /www/client/src/components/Icon/route.svg
// module id = 975
// module chunks = 0